import { render, staticRenderFns } from "./Suporte.vue?vue&type=template&id=a9d72406&scoped=true&"
import script from "./Suporte.vue?vue&type=script&lang=js&"
export * from "./Suporte.vue?vue&type=script&lang=js&"
import style0 from "./Suporte.vue?vue&type=style&index=0&id=a9d72406&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9d72406",
  null
  
)

export default component.exports